<template>
  <div class="section">
    <div class="title-box" v-if="title">
      <div class="title-bg"><span></span></div>
      <div class="title">
        <div class="title-text MF_1">
        <img class="star-a" src="@/assets/images/star-a.svg" alt="star" srcset=""> 
        {{ title }}
        <img class="star-b" src="@/assets/images/star-a.svg" alt="star" srcset="">
        </div>
      </div>
    </div>
    <div class="content">
      <div class="bot-bg"></div>
      <div class="dynamic-list-box">
        <div class="dynamic-list" id="left-list">
          <div class="dynamic-list-grid">
            <div
              class="dynamic-item"
              v-for="item in leftList"
              :key="item.id"
              @click="goToDetail(item)"
            >
              <div class="dynamic-images">
                <img v-for="(img, idx) in item.images" :key="idx" :src="img" class="dynamic-img" />
                <!-- <img src="https://jihuanshe-imagex.jihuanshe.com/pkm/card_versions/CS4bC-085_sc.png" :alt="item.title" class="dynamic-img" /> -->
              </div>
              <div class="dynamic-content">
                <div class="dynamic-title ells2 EN_7_Regular" v-if="item.title">{{ item.title }}</div>
                <div class="dynamic-author">
                  <img class="author-avatar" :src="getAuthorInfo(item).avatar" :alt="getAuthorInfo(item).username" />
                  <span class="author-name EN_7_Regular ells1">{{ getAuthorInfo(item).username }}</span>
                </div>
                <div class="blank-box" v-if="item.remark"></div>
              </div>
              <div class="dynamic-remark CH_6_Regular" v-if="item.remark"><span class="ells2">{{ item.remark }}</span></div>
            </div>
          </div>
        </div>
        <div class="dynamic-list" id="right-list">
          <div class="dynamic-list-grid">
            <div
              class="dynamic-item"
              v-for="item in rightList"
              :key="item.id"
              @click="goToDetail(item)"
            >
              <div class="dynamic-images">
                <img v-for="(img, idx) in item.images" :key="idx" :src="img" class="dynamic-img" />
                <!-- <img src="https://jihuanshe-imagex.jihuanshe.com/pkm/card_versions/CS4bC-085_sc.png" :alt="item.title" class="dynamic-img" /> -->
              </div>
              <div class="dynamic-content">
                <div class="dynamic-title ells2 EN_7_Regular" v-if="item.title">{{ item.title }}</div>
                <div class="dynamic-author">
                  <img class="author-avatar" :src="getAuthorInfo(item).avatar" :alt="getAuthorInfo(item).username" />
                  <span class="author-name EN_7_Regular ells1">{{ getAuthorInfo(item).username }}</span>
                </div>
                <div class="blank-box" v-if="item.remark"></div>
              </div>
              <div class="dynamic-remark CH_6_Regular" v-if="item.remark"><span class="ells2">{{ item.remark }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!expanded && dynamicList.length > 4" class="more-btn-box">
      <div class="more-btn" @click="openExpanded"><span class="EN_6_Regular">{{ $t('common.more') }}</span><span class="JHSicon JHS-arrow_down"></span></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { checkLoginAndGo } from '@/utils/token';
import { track } from '@/utils/tracking';

declare const jhsapp: any;
interface DynamicAuthor {
  avatar: string;
  id: number;
  username: string;
}

interface DynamicItem {
  id: number;
  title: string;
  author: DynamicAuthor;
  images: string[];
  remark: string;
  link: string;
  game_key: string;
}

const props = defineProps<{ 
  dynamicList: DynamicItem[]; 
  title: string; 
  module_ID: string; 
  module_type: string 
}>();

const expanded = ref(false);

const leftList = computed(() => {
  const list = props.dynamicList.filter((_, index) => index % 2 === 0);
  return expanded.value ? list : list.slice(0, 2);
});

const rightList = computed(() => {
  const list = props.dynamicList.filter((_, index) => index % 2 === 1);
  return expanded.value ? list : list.slice(0, 2);
});

const openExpanded = () => {
  checkLoginAndGo(()=>{
    expanded.value = true;
  })
}

const getAuthorInfo = (item: DynamicItem) => {
  return {
    avatar: item.author?.avatar,
    username: item.author?.username
  };
};

// 跳转详情页
function goToDetail(item: DynamicItem) {
  track('H5Landing_module_operation', {
    operation: 'click_on_link_dynamic',
  });

  track('lst_H5Landing_module_discovery', {
    module_ID: props.module_ID,
    module_type: props.module_type,
    index: item.id,
    dynamic_content_id: item.id,
    creator_user_id: item.author?.id,
    title_name: item.title,
    game_key: item.game_key,
  });

  checkLoginAndGo(()=>{
    try {
      if (item.link) {
        jhsapp.router(item.link);
      } else  {
        jhsapp.router(`https://www.jihuanshe.com/app/dynamicContent?dynamicContentId=${item.id}`);
      }
    } catch (error) {
      console.error('跳转失败:', error);
    }
  })
}
</script>

<style lang="scss" scoped>
@import '@/styles/section.scss';

.dynamic-list-box{
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--gap-8);
}

.dynamic-list {
  position: relative;
  width: 100%;
}

.dynamic-list-grid {
  display: flex;
  flex-direction: column;
  gap: var(--gap-8)
}
.dynamic-item {
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.08);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 0;
  border-radius: var(--corner-5);
}
.dynamic-images {
  display: flex;
  gap: 4px;
  width: 100%;
  max-height: 255px;
  padding: 0;
  background: #f7f7f7;
  align-items: flex-start;
}
.dynamic-img {
  flex: 1 1 0;
  display: none;
  // height: 169px;
  object-fit: cover;
  border-radius: 0;
}
.dynamic-img:first-child {
  display: block;
}
.dynamic-content {
  display: flex;
  max-height: 97px;
  padding: var(--padding-6);
  flex-direction: column;
  align-items: flex;
  gap: var(--gap-6);
  background: var(--container-surface-grey);

  .blank-box {
    height: 19px;
  }
}

.dynamic-title {
  max-height: 32px;
  flex-shrink: 0;
  color: var(--on-container-text-primary);
}
.dynamic-author {
  display: flex;
  align-items: center;
  gap: var(--gap-3);
  // flex: 1 0 0;
}
.author-avatar {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #eee;
}
.author-name {
  color: var(--on-container-text-primary);
}
.dynamic-remark {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 52px;
  flex-shrink: 0;
  background: var(--container-surface-white);
  border-radius: var(--corner-7);
  box-shadow: 0px var(--container-effects-thickness-3) var(--container-effects-thickness-6) 0px var(--container-effects-color-gray-subtle);
  margin-top: -19px;
  padding: 8px 13px;
  background: #fff;
}
</style> 